import React from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"
import Divider from "components/UI/Divider"
import CompanyWithIcon from "components/UI/CompanyWithIcon"
import DropdownMenu from "components/UI/DropdownMenu"
import linkResolver from "../../../utils/linkResolver"
import t, { mixin } from "theme"

const DesktopCompanyTabs = ({ commonData, selectedCompany, selectedFeature }) => {
    const companies = commonData.liveCompanies

    return (
        <div
            css={css`
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
            `}>
            <div
                css={css`
                    display: flex;
                    align-items: center;
                `}>
                {companies.map((company, index) => (
                    <div
                        css={css`
                            display: flex;
                            align-items: center;
                        `}>
                        <Link to={`/stock/${company.ticker.toLowerCase()}`}>
                            <CompanyWithIcon company={company} size={t.font.size[3]} />
                        </Link>
                        {index + 1 < companies.length && (
                            <Divider direction="V" space={t.space[5]} color={t.color.subtlegrey} />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

const CompanyDropdown = ({ commonData, selectedCompany, selectedFeature }) => {
    const companies = commonData.liveCompanies

    const companiesMenu = companies.map((company, index) => ({
        id: company.ticker,
        label: <CompanyWithIcon company={company} size={t.font.size[3]} />,
        pathname: linkResolver({ type: "OVERVIEW", ticker: company.ticker }),
    }))

    return (
        <DropdownMenu
            selected={selectedCompany ? selectedCompany.ticker : null}
            choices={companiesMenu}
            backup={
                selectedCompany ? (
                    <CompanyWithIcon company={selectedCompany} size={t.font.size[3]} />
                ) : (
                    <div>SELECT COMPANY</div>
                )
            }
            css={css`
                ${mixin.phonestyle} {
                    width: ${selectedCompany ? "35vw" : "90vw"};
                }
            `}
        />
    )
}

export { DesktopCompanyTabs, CompanyDropdown }
